import { BaseTheme } from '../BaseTheme';
import { ICometThemePalette } from '../ICometThemePalette';
import { CometThemeToggleButtonStyles } from './CometThemeToggleButtonStyles';
import { ISemanticSiteHeaderStyles } from './ISemanticSiteHeaderStyles';
import { IToggleButtonStyles } from './IToggleButtonStyles';

export class CometThemeSiteHeaderStyles implements ISemanticSiteHeaderStyles {
    private toggleButtonWidth = 42;
    private toggleButtonHeight = 45;
    private iconFontSize = 16;
    constructor(
        private theme: BaseTheme,
        private height: number,
        private cometPalette: ICometThemePalette
    ) {
        this.toggleButtonStyles = new CometThemeToggleButtonStyles(
            this.theme,
            this.toggleButtonHeight,
            this.toggleButtonWidth,
            this.cometPalette.darkPrimaryAlt,
            this.cometPalette.lightPrimary,
            this.cometPalette.lightPrimaryAlt
        );
    }
    toggleButtonStyles: IToggleButtonStyles;

    get stackStyles() {
        return {
            root: {
                paddingRight: '36px',
                paddingLeft: '32px',
                flexShrink: 0,
                background: this.cometPalette.darkPrimary,
                minHeight: this.height,
            },
            inner: {
                maxWidth: '100%',
            },
        };
    }

    get customMenuItemContainer() {
        return { borderBottom: `1px solid ${this.theme.semanticColors.bodyDivider}` };
    }

    get contextualMenuStyles() {
        return {
            list: {
                '.ms-ContextualMenu-item': {
                    height: 'auto',
                    paddingLeft: 5,
                    paddingRight: 5,
                    paddingBottom: 2,
                    paddingTop: 2,
                },
            },
        };
    }
    get iconStyles() {
        return {
            root: { fontSize: this.iconFontSize },
        };
    }
}
